import { inputAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(inputAnatomy.keys);

const baseStyle = definePartsStyle({
  field: {
    border: '1px solid',
    borderColor: ' gray.200',
    borderRadius: '4px',
    fontSize: '14px',
    color: 'gray.400',
    _placeholder: { color: 'gray.300' },
  },
});

const sizes = {
  md: definePartsStyle({
    field: { fontSize: '14px', py: '14px', px: '18px', h: '44px' },
  }),
};

const variants = {
  default: definePartsStyle({
    field: {
      bg: 'white',
      color: 'gray.500',
      _placeholder: { color: 'gray.300' },
    },
  }),
  dark: definePartsStyle({
    field: {
      color: 'gray.300',
      _placeholder: { color: 'gray.500' },
    },
  }),
};

export const Input = defineMultiStyleConfig({
  baseStyle,
  sizes,
  variants,
  defaultProps: { size: 'md', variant: 'default' },
});
